import {
  ApiResponse,
  ArrayDataResponse,
  SimpleStringResponse,
  UserDownloadResponse,
  UserUIResponse,
} from "../../models/ApiResponse";
import { ResetPasswordRequest } from "../../models/requestModels/resetPasswordRequest";
import {
  AddUserRequest,
  BulkUserRequest,
  UpdateUserRequest,
} from "../../models/requestModels/userRequest";
import { UserResponse } from "../../models/responseModels/userResponse";
import { axiosRequests } from "../axiosRequest";

export const UserAgent = {
  getUserList: () => axiosRequests.get<UserUIResponse>("/auth/user/all"),
  userCsvDownload: (userData: UserResponse[]) =>
    axiosRequests.post<UserDownloadResponse>("/user/DownloadCsv", userData),
  userXlsxDownload: (userData: UserResponse[]) =>
    axiosRequests.postXlsx<Blob>("/user/DownloadXlsx", userData),
  addUser: (formData: FormData, fdpId: string) =>
    axiosRequests.postWithFormData<ApiResponse>(
      `/auth/user/new?fdpId=${fdpId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    ),
  updateUser: (formData: FormData) =>
    axiosRequests.putWithFormData<ApiResponse>("/auth/user/update", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
  updateUserStatus: (userIds: string[], deleteStatus: boolean, activationPeriod?: number) =>
    axiosRequests.put<ApiResponse>(
      `/auth/user/update/status?deleteStatus=${encodeURIComponent(deleteStatus.toString())}${activationPeriod !== undefined ? `&activationPeriod=${encodeURIComponent(activationPeriod.toString())}` : ''}`,
      userIds
      ),
  addBulkUser: (bulkUsers: BulkUserRequest, fdpId: number) =>
    axiosRequests.post<ArrayDataResponse>(
      `/auth/user/bulk/new?fdpId=${fdpId}`,
      bulkUsers
    ),
  deleteUser: (userData: UpdateUserRequest) =>
    axiosRequests.post<ApiResponse>("auth/user/delete", userData),
  resetUserPassword: (resetPasswordDto: ResetPasswordRequest) =>
    axiosRequests.put<ApiResponse>(
      "/auth/user/reset-password",
      resetPasswordDto
    ),
  generateUserPassword: (email: string) =>
    axiosRequests.get<ApiResponse>(
      `/auth/user/generate-password?email=${email}`
    ),
  forgotUserPassword: (username: string) =>
    axiosRequests.get<ApiResponse>(
      `/auth/public/user/forgot-password/${username}`
    ),
  resetPasswordByToken: (
    resetPasswordDto: ResetPasswordRequest,
    token: string
  ) =>
    axiosRequests.post<ApiResponse>(
      `/auth/public/reset-password/${token}`,
      resetPasswordDto
    ),
  generateOtpForuser: (userId: string) =>
    axiosRequests.get<SimpleStringResponse>(
      `/auth/user/generate/otp?userId=${userId}`
    ),
  fetchFdpUserDoc: (fileType: string, userId: string) =>
    axiosRequests.getWithQueryParamAndReturnBlob<Blob>(`/auth/fdp/user/doc`, {
      params: { fileType, userId },
      responseType: "blob",
    }),
};
